import qr from "query-string";
import { useQuery } from "@tanstack/react-query";
import { API, fetcher, PaginationResponse } from "@/shared/core-configs";
import { Kit } from "../types/Kit";
import { Pagination } from "@/shared/core-configs";

export const GET_CORE_KITS_FETCH_KEY = "@CORE_KITS_GET_KITS_KEY";

type GetProductKitsParams = {
  showDisabled?: boolean;
  searchTerm?: string;
  storageId?: string | string[];
} & Partial<Pagination>;

export const getKits = async (
  page?: number,
  pageSize?: number,
  showDisabled?: boolean,
  searchTerm?: string,
  storageId?: string | string[],
) => {
  const params = qr.stringify({
    page,
    pageSize,
    showDisabled,
    searchTerm,
    storageId,
  });
  const response = await fetcher.get(`${API.GESLUB_SERVICE}/kits?${params}`);
  return response.data;
};

export const useGetKits = ({
  storageId,
  page,
  pageSize,
  showDisabled,
  searchTerm,
}: GetProductKitsParams = {}) => {
  const { data, isPending, error } = useQuery<PaginationResponse<Kit>, Error>({
    queryKey: [
      GET_CORE_KITS_FETCH_KEY,
      page,
      pageSize,
      showDisabled,
      searchTerm,
      storageId,
    ],
    queryFn: () => getKits(page, pageSize, showDisabled, searchTerm, storageId),
    placeholderData: (prev) => prev,
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination,
    isPending,
    error,
  };
};
